import CourseLoader from 'containers/CourseLoader'
import CourseDetails from './CourseDetails.jsx'

export default class CourseDetailsRoute extends React.PureComponent {
  static propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        id: PropTypes.string,
      }),
    }).isRequired,
  }

  render() {
    const { match } = this.props
    return (
      <CourseLoader match={match}>
        <CourseDetails />
      </CourseLoader>
    )
  }
}
